import React from "react"
import { Container, Row, Col } from "react-bootstrap";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
import * as styles from "./AnimationDetailsPanel.module.scss";
import "./animationDetails.scss";
import { GeneralSizeKeyToPaddingNumber  } from "../../../utils/datasources"

import AnimationWrapper from "../../internal/animationWrapper/AnimationWrapper";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";

const AnimationPanelDetails = ({ blok }) => {
    const [isAnimating, setIsAnimating] = useState("")
    const containerRef = useRef(null);
    const [ isVisible, setIsVisible] = useState(false)
    const triggerAnimate = (entries) => {
        const [entry] = entries;
        console.log(entry)
        if(entry.isIntersecting){
            setIsAnimating(styles.animate);
        }
    }
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }
    useEffect(() => {
        const observer = new IntersectionObserver(triggerAnimate, options);
        if(containerRef.current) observer.observe(containerRef.current);

        return () => {
            if(containerRef.current) observer.unobserve(containerRef.current);
        }
        
    }, [containerRef, options]);

   return(
    <AnimationWrapper blok={blok}>
        {blok.grey ? <div ref={containerRef}></div> : null}
        <Container className={blok.grey ? `${styles.grey} ${isAnimating}`: null} id={blok.grey ? "anim-block" : null}>

            <Row>
                <Col xs={12} sm={6} className={styles.contextBlock}>
                    <div className={styles.contextWrap}>
                        {blok.headline ? <h2>{blok.headline}</h2> : null }
                        {blok.location ? <h3 className={styles.location}>{blok.location}</h3>: null }
                        <div dangerouslySetInnerHTML={resolveRichText(blok.context)}></div>
                    </div>
                </Col>
                <Col xs={12} sm={6} className={styles.metricBlock}>
                {/* <Col xs={12} sm={6} className={styles.metricBlock}> */}
                {blok.metric ?<div dangerouslySetInnerHTML={resolveRichText(blok.metric)} className={styles.metricContent}></div>: null}
                </Col>
            </Row>
        </Container>
    </AnimationWrapper>
    
   )
}
    
 
export default AnimationPanelDetails;